
import { Button, Flex, Heading } from 'rebass';
import { boxShadow, border } from 'styled-system';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import store from 'store';

const Outer = styled(Flex)`
  ${border};
  ${boxShadow};
`;

const Inner = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  max-width: 600px;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 8px;
`;

const NewStoryHeader = ({ onCancel, onBack, onNext, nextButtonText = "Next", title, disabled }) => {
  const isRespondingToRequest = store.get('requestResponse') === 'true';

  return (
    <Outer
      pt={[1, 5]}
      pb={4}
      justifyContent="center"
      m="auto"
      mb={3}
      borderBottom="1px solid #E2E8F0"
      maxWidth="700px"
    // boxShadow="small"
    >
      <Inner>
        {!isRespondingToRequest && onCancel && (
          <Button
            disabled={disabled}
            type="button"
            fontSize={16}
            fontFamily="Poppins"
            fontWeight={500}
            lineHeight="120%"
            letterSpacing="-0.352px"
            variant="transparent"
            onClick={onCancel}
            color="#64748B"
            sx={{ display: ['none', 'inline-block'] }}
            css="grid-column: 1 / 2; justify-self: start;"
          >
            Cancel
          </Button>
        )}
        {onBack && (
          <Button
            disabled={disabled}
            type="button"
            fontSize={16}
            fontFamily="Poppins"
            fontWeight={500}
            lineHeight="120%"
            letterSpacing="-0.352px"
            color="#9B59B6"
            variant="transparent"
            onClick={onBack}
            sx={{ display: ['none', 'inline-block'] }}
            css="grid-column: 1 / 2; justify-self: start;"
          >
            {'<'} Back
          </Button>
        )}
        <Heading
          fontFamily="Poppins"
          color="#333"
          fontSize="22px"
          fontWeight={500}
          width="max-content"
          css="grid-column: 2 / 3; justify-self: center;"
        >
          {title}
        </Heading>
        {onNext && (
          <Button
            height={44}
            variant="primary"
            p="10px 20px"
            css="grid-column: 3 / 4; justify-self: end; border-radius:23px;"
            disabled={disabled}
            type="button"
            onClick={onNext}
            sx={{ display: ['none', 'inline-block'] }}
          >
            {nextButtonText}
          </Button>
        )}
      </Inner>
    </Outer>
  );
};

NewStoryHeader.propTypes = {
  onCancel: PropTypes.func,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  nextLabel: PropTypes.string,
};

NewStoryHeader.defaultProps = {
  onCancel: null,
  onBack: null,
  onNext: null,
  title: '',
  disabled: false,
  nextLabel: 'Next',
};

export default NewStoryHeader;
